import { Button } from '@components/ui/Button/Button';
import { Title } from '@components/ui/Title/Title';
import { AppRoutes } from '@types';
import Success from 'public/illustrations/happy.svg';
import React from 'react';

import styles from './Steps.module.scss';

interface SuccessStepProps {
  onClose: () => void;
}

export const SuccessStep: React.FC<SuccessStepProps> = ({ onClose }) => (
  <div className={styles.wrapper}>
    <div className={styles.content}>
      <div className={styles.label}>Tour complete</div>
      <Title
        className={styles.title}
        htmlElement="h2"
      >
        Great work! 🎉
      </Title>
      <p>Now that you’re familiar with Calvin Risk building blocks, you’re ready to get started.</p>
      <p>
        The{' '}
        <a
          href={`/cal${AppRoutes.dashboard}`}
          target="_blank"
          rel="noreferrer"
        >
          dashboard
        </a>{' '}
        is the homebase for gaining an overview of your AI Risk.
      </p>
      <div className={styles.button}>
        <Button
          view="primary"
          link={{ url_label: 'Go to Calvin Platform', url: `/cal${AppRoutes.dashboard}`, withoutBase: true }}
          onClick={onClose}
        />
      </div>
    </div>
    <div>
      <Success />
    </div>
  </div>
);
